import { useState, useEffect } from 'react'
import { doc, getDoc, setDoc, getFirestore } from 'firebase/firestore'
import { EmailTemplate, DEFAULT_TEMPLATES } from '../../../../types/emailTemplates'
import { primaryServices } from '../../../../utils/firebaseServiceContext'

const useEmailTemplate = (key: string) => {
  const [template, setTemplate] = useState<EmailTemplate>(
    DEFAULT_TEMPLATES[key] ?? { subject: '', body: '' }
  )
  const [isLoading, setIsLoading] = useState(true)
  const [isSaving, setIsSaving] = useState(false)

  useEffect(() => {
    getDoc(doc(primaryServices.firestore, 'settings', 'emailTemplates'))
      .then((snap) => {
        const data = snap.data()?.[key] as EmailTemplate | undefined
        if (data?.subject && data?.body) setTemplate(data)
      })
      .finally(() => setIsLoading(false))
  }, [key])

  const save = async (values: EmailTemplate) => {
    setIsSaving(true)
    try {
      await setDoc(
        doc(primaryServices.firestore, 'settings', 'emailTemplates'),
        { [key]: values },
        { merge: true }
      )
      setTemplate(values)
    } finally {
      setIsSaving(false)
    }
  }

  return { template, isLoading, isSaving, save }
}

export default useEmailTemplate
